import type { FAQItem } from './types';

export const paymentsFAQs: FAQItem[] = [
  {
    id: 'payment-methods-supported',
    question: 'Which payment methods are supported (ACH, credit/debit)?',
    answer: `Payment collection is designed to support assessments, facility fees, and invoices via:

• **ACH (bank transfer)** — lowest processing cost; settlement in 2–5 business days
• **Credit/Debit cards** — higher convenience; standard card network fees apply

Card/ACH processing would run through a third-party payment processor; we would not store card numbers, and PCI compliance would be managed by that processor. This integration is not yet built; it is scoped for implementation, not live today.`,
    category: 'payments',
  },
  {
    id: 'convenience-fees-policy',
    question: 'Can we pass processing fees to payers as a convenience fee?',
    answer: `The design supports either model:

• **Community absorbs fees** as an operating expense, or
• **Pass-through convenience fees** to the payer at checkout

Important: Local/state rules and your bylaws may affect how fees can be handled. Consult community counsel; we provide the configuration, not legal advice. Payment processing itself is not yet built.`,
    category: 'payments',
  },
  {
    id: 'chargebacks-and-disputes',
    question: 'How are chargebacks or payment disputes handled?',
    answer: `Once payment processing is built, disputes would flow through the payment processor with supporting documentation from your portal records:

• Resident, invoice, and communication records would aid dispute responses
• Funds may be held by the processor during review
• Outcomes and adjustments would be reflected in your ledger

This workflow is planned, not live: no payment processor is integrated today.`,
    category: 'payments',
  },
  {
    id: 'deposits-and-returns',
    question: 'Can we collect security deposits (e.g., facilities) and process deposit returns?',
    answer: `Security deposits for facilities or special events are planned functionality:

• Deposits would be paid during booking
• After inspection, admins would approve **full/partial deposit return**
• Deposit return would be processed back to the original payment method via the processor

This depends on the same payment processor integration described above, which is not yet built.`,
    category: 'payments',
  },
  {
    id: 'violation-fines-fees',
    question: 'Can we collect violation fines, new resident setup fees, and other HOA charges?',
    answer: `The platform is designed to support collecting various HOA fees beyond regular assessments:

**What YOU Would Be Able to Charge (HOA-Controlled):**
• Violation fines and penalties
• New resident setup/transfer fees
• Architectural review application fees
• Late payment penalties
• Special assessment fees
• Any other fees defined in your bylaws

**Important:** These would be fees YOUR HOA sets and collects, we provide the payment collection tools. You decide what to charge, when to charge it, and who pays it based on your community's bylaws and policies. Collection of these fees depends on payment processing, which is not yet built.

**What We Do Not Plan to Charge (Unlike Competitors):**
• No voting fees (many competitors charge per vote or per ballot)
• No work order submission fees
• No document access fees
• No per-transaction fees for resident actions

Our pricing model is platform fee plus data usage only, with no hidden transaction fees.`,
    category: 'payments',
  },
  {
    id: 'processing-fees',
    question: 'Are there payment processing fees and who pays them?',
    answer: `Payment processing is not yet built. When implemented, payments would run through a third-party payment processor, and standard card/ACH processing fees would apply.

Communities would choose one of two approaches:
• The community absorbs processing fees as an operating expense
• Fees are passed through to the payer during checkout

Your policy would be configurable during implementation so it matches your bylaws and budget approach.`,
    category: 'payments',
  },
];
